module.exports = __webpack_public_path__ + "media/images/illustration/undraw_Home_settings_re_pkya-911afbe52e5adda861cc487f281a0b50.svg";